import React, {useEffect, useState} from 'react';

import WorkOrderDatatable from '../workOrder/WorkOrderDatatable';





const DocumentOperationsProcessingListTab = (props) => {

    
  const [show , setShow]= useState( false );
  const [recordId, setRecordId ] = useState();    
  const [checkTime, setCheckTime] = useState(null);
  const [showAndRecordId, setShowAndRecordId] = useState(
    {
      show: false,
      recordId: ''
    }
  );

  const handleCallback = (id) => {      
    if(id!==''){
      props.parentCallback(id,'DETAIL');
    }else{
           
        modalCallback(true,id);
      

    }
  };

  const modalCallback = (show,id) => {             
      setRecordId(id);  
      setShow(show);          
   
  }



  useEffect(() => {      
    setCheckTime(Date.now());
  }, [props.isActive])


  return (
      <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
      
        <WorkOrderDatatable      
          parentCallback={handleCallback}  
          modalCallback={modalCallback}  
          modalShow={show}    
          checkTime={checkTime}   
          hideEdit={true}                         
        />
       
      
       
      </div>
  );
};

export default DocumentOperationsProcessingListTab;